import React from 'react';
import { Pie } from '../../graphs';
import { sortByLabels } from './selectors';

export const HalfPagePie = ({ title, valuesByKey }) => {
  return (
    <div
      style={{
        height: 300,
        width: '50%',
        minWidth: 300,
        display: 'inline-block',
      }}
    >
      <span>{title}</span>
      <Pie
        data={Object.keys(valuesByKey)
          .map((key) => ({
            value: valuesByKey[key][valuesByKey[key].length - 1].y,
            label: key,
            id: key,
          }))
          .sort(sortByLabels)}
      />
    </div>
  );
};
